import React, { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { TEXTS } from './texts';
import { PLAYER_NAME_TYPE } from '../SelectPlayerModal/consts';
import { useOnboardingContext } from '../useOnboardingContext';

import styles from './index.module.scss';

const ChangeDeviceWarningModal: FC<ModalProps[ModalTypes.CHANGE_DEVICE_WARNING]> = ({ close, replaceModal }) => {
  const { currentPoint } = useOnboardingContext();

  return (
    <ModalScreen
      title={TEXTS.MODAL_TITLE}
      titlePlacement="left"
      onClose={close}
      contentClassName={styles.ChangeDeviceWarningModal}
      actionButtons={[
        <Button
          key="change_device_warning_modal_submit"
          elementId="change_device_warning_modal_submit"
          onClick={() => {
            replaceModal(ModalTypes.SELECT_PLAYER_MODAL, {});
          }}>
          {TEXTS.MODAL_BUTTON_SUBMIT}
        </Button>,
        <Button
          key="change_device_warning_modal_cancel"
          elementId="change_device_warning_modal_cancel"
          type={ButtonType.SECONDARY}
          onClick={() => close()}>
          {TEXTS.MODAL_BUTTON_CANCEL}
        </Button>,
      ]}>
      <span className={styles.ChangeDeviceWarningModalDescription}>{TEXTS.MODAL_DESCRIPTION}</span>

      <div>
        <span
          className={styles.ChangeDeviceWarningModalNote}>{`${TEXTS.MODAL_NOTE_ADDRESS} ${currentPoint.address}`}</span>
        {currentPoint.device?.type && (
          <span
            className={
              styles.ChangeDeviceWarningModalNote
            }>{`${TEXTS.MODAL_NOTE_DEVICE} ${PLAYER_NAME_TYPE[currentPoint.device?.type]}`}</span>
        )}
      </div>
    </ModalScreen>
  );
};

export default memo(ChangeDeviceWarningModal);
